export const skilldata=[
    
    {
        label:"LANGUAGES",
        data:[
            {
                skill:"C Language",
                percent:"80",
            },
            {
                skill:"C++",
                percent:"85",
            },
            {
                skill:"Java",
                percent:"50",
            },
            {
                skill:"Python",
                percent:"90",
            }
        ]
    },
    {
        label:"WEB DEVELOPMENT",
        data:[
            {
                skill:"HTML",
                percent:"90",
            },
            {
                skill:"CSS",
                percent:"70",
            },
            {
                skill:"React JS",
                percent:"60",
            },
            {
                skill:"Java script",
                percent:"60",
            }
        ]

    },
    {
        label:"OTHERS",
        data:[
            {
                skill:"Machine Learning",
                percent:"65",
            },
            {
                skill:"Data Science",
                percent:"65",
            },
            {
                skill:"My SQL",
                percent:"50",
            }
        ]
    },
]